import IndexRouter from "./Router/indexRoute";
import { AuthProvider } from "./services/AuthServices";
import { BrowserRouter } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AlertProvider } from "./services/AlertServices";

function App() {
  return (
    <div className="App" style={{ backgroundColor: "red", width: "100%" }}>
      <BrowserRouter>
        <AuthProvider>
          <AlertProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <IndexRouter />
            </LocalizationProvider>
          </AlertProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
